import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  phoneNumber: string;
};

export const Called: FC<Props> = ({ phoneNumber }) => (
  <div className="banner-customers__subtitle">
    <b>
      <FormattedMessage id="home-expired/components/Called.tsx/1" />
      <br /> <FormattedMessage id="home-expired/components/Called.tsx/2" />
      {phoneNumber && (
        <span>
          {' '}
          <FormattedMessage id="home-expired/components/Called.tsx/3" />
          {'\u00a0'}
          <span>
            {phoneNumber}
            <FormattedMessage id="home-expired/components/Called.tsx/4" />
          </span>
        </span>
      )}
    </b>
  </div>
);
